/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import {ControlLabel , Row , Col , FormGroup , FormControl} from 'react-bootstrap';
import DataInput from '../../inputs/date.input.js'
import Select from  'react-select';
import LanguageSelector from "../../inputs/language-selector.js";
import IntelStore from "../../../store/internationalization-store.js"
import DatePicker from 'react-datepicker';
import moment from 'moment';
import DateHelper from "../../../classes/date.js";

import 'react-datepicker/dist/react-datepicker.css';
import InternationalizationStore from '../../../store/internationalization-store.js';

const allOptions = [
    { value: 4 , label:  <FormattedMessage id={ 'ui-117' } defaultMessage={ 'Listening' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 10 , label: <FormattedMessage id={ 'ui-119' } defaultMessage={ 'Reading' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 1 , label: <FormattedMessage id={ 'ui-118' } defaultMessage={ 'Speaking' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/>},
    { value: 7 , label: <FormattedMessage id={ 'ui-120' } defaultMessage={ 'Writing' }/> , noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> }]

const coreOptions = [
    { value: 4 ,  label: <FormattedMessage id={ 'ui-117' } defaultMessage={ 'Listening' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 10 , label: <FormattedMessage id={ 'ui-119' } defaultMessage={ 'Reading' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 7 ,  label: <FormattedMessage id={ 'ui-120' } defaultMessage={ 'Writing' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/>  }]

class ContentStep extends React.Component {

    constructor(props){
        super();
        moment.locale(InternationalizationStore.determineLocaleFromBrowser());
        this.props = props;

        console.log(this.props);


        let tests = [];

        if(props.data.tests)
        {
            for(var idx = 0;  idx < allOptions.length; idx++)
            {
                console.log(props.data.tests.indexOf(allOptions[idx].value))
                if(props.data.tests.indexOf(String(allOptions[idx].value)) >= 0)
                {
                    tests.push(allOptions[idx]);
                }
            }

        }


        if(!this.props.data.games && tests.length > 0){
            this.props.data.games = tests;
        }


        this.state = {
            games:this.props.data.games || allOptions,
            options:allOptions,
            selectedLanguage:null,
            name : this.props.data.className || ""
        };

        var d =   new Date();
        var due = new Date(); due.setDate(due.getDate() + 14);

        this.props.data.set =  (new DateHelper()).getDate(String(this.props.data.set)).getUnixTime();
        this.props.data.due = (new DateHelper()).getDate(String(this.props.data.due)).getUnixTime();

        //this.props.data.games = this.props.data.games || allOptions;

        this.handelGamesChange = this.handelGamesChange.bind(this);
        this.handelSelectLanguage = this.handelSelectLanguage.bind(this);
        this.handelSetDataSelect = this.handelSetDataSelect.bind(this);
        this.handelDueDataSelect = this.handelDueDataSelect.bind(this);
        this.handelClassNameChange = this.handelClassNameChange.bind(this);
    }

    componentDidMount(){

    }


    handelGamesChange(value){

        if(value.length > 0)
        {
            this.setState({games:value});
            this.props.data.games = value;
        }
    }

    handelSelectLanguage(language){

        if(!language.hasSpeaking)
        {
            this.props.data.games = coreOptions;
            this.setState({games:coreOptions ,  options : coreOptions});
        }
        else
        {
            this.props.data.games = allOptions;
            this.setState({games:allOptions ,  options : allOptions});
        }

        this.props.data.selectedLanguage = language;
        this.setState({selectedLanguage : language});
    }

    handelSetDataSelect(val){
        this.props.data.set = (new Date(val)).getUnixTime();
    }

    handelDueDataSelect(val){
        this.props.data.due = (new Date(val)).getUnixTime();
    }

    handelClassNameChange(e){

        if(e.target.value.length >= 100)
        {
            return
        }

        this.setState({name:e.target.value});
        this.props.data.className = e.target.value;
    }

    renderGamesSelect(){

        console.log(this.state.games)
        return <Select onChange={this.handelGamesChange} value={this.state.games} multi={true}  options={this.state.options} 
                noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>;
    }

    render(){

        return <div>
                    <Row>
                        <Col sm={12}>
                            <FormGroup className="fg-line fg-toggled">
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-2008' } defaultMessage={ 'Assignment Name' }/><small></small></ControlLabel>
                                <FormControl autoFocus value={this.state.name} type="text" onChange={this.handelClassNameChange}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup className="fg-line">
                                <ControlLabel  className="fg-label pull-left"><FormattedMessage id={ 'ui-2009' } defaultMessage={ 'Choose Test Type' }/><small></small></ControlLabel>
                            {this.renderGamesSelect()}
                        </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}><DataInput onSelect={this.handelSetDataSelect} value={this.props.data.set} labelTranslationUID="ui-483" labelName="Set"/></Col>
                        <Col sm={6}><DataInput onSelect={this.handelDueDataSelect} value={this.props.data.due} labelTranslationUID="ui-484" labelName="Due"/></Col>
                    </Row>
                </div>
    }
}

export default {
    name: <FormattedMessage id={ 'ui-893' } defaultMessage={ 'About' }/>,
    title:null,
    onSubmit: function (done){

        if(!this.props.data.className || this.props.data.className.length == 0)
        {
            return done(new Error(IntelStore.getTranslation("ui-894")));
        }


        done();
    },
    component: ContentStep
}


// WEBPACK FOOTER //
// ./src/components/wizard/assignment-steps/about-assignments-edit.js